import PropTypes from 'prop-types';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import { LogoutOutlined, UserOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { activeItem } from 'store/reducers/menu';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
    const theme = useTheme();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    const goToProfile = () => {
        dispatch(activeItem({ openItem: ['profile'] }));
        navigate('/profile')
    }


    return (
        <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
            <ListItemButton selected={selectedIndex === 2} onClick={goToProfile}>
                <ListItemIcon>
                    <UserOutlined />
                </ListItemIcon>
                <ListItemText primary="Profile" />
            </ListItemButton>
            <ListItemButton selected={selectedIndex === 2} onClick={() => window.open('https://docs.google.com/document/d/1rVHo1HvmmIAtikKANP2waITCzjwTTNQ0FJBuuZtIcIU/edit?usp=sharing', '_blank')}>
                <ListItemIcon>
                    <InfoCircleOutlined />
                </ListItemIcon>
                <ListItemText primary="About" />
            </ListItemButton>
            <ListItemButton selected={selectedIndex === 2} onClick={() => handleLogout('redirect')}>
                <ListItemIcon>
                    <LogoutOutlined />
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItemButton>
        </List>
    );
};

ProfileTab.propTypes = {
    handleLogout: PropTypes.func
};

export default ProfileTab;
